<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da tela -->
          <basic-toolbar :title="'Cadastrar Membro Externo'"></basic-toolbar>

          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <!-- Mensagem sobre o ExCAD -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <div class="center">
                      <v-card outlined>
                        <v-card-text class="black--text font-weight-bold">
                          Cadastre o membro externo preenchendo os dados do formulário abaixo. Caso o membro externo necessite ter acesso aos sistemas corporativos da UFES ou ao
                          <a href="http://nti.ufes.br/eduroam" target="_blank">Eduroam</a>, o cadastro deve ser realizado por meio do sistema <a href="url" id="excadLink" target="_blank">ExCAD - Extensão do Cadastro</a>.
                          Para obter maiores informações sobre o sistema ExCAD, clique no link a seguir: <a href="http://www.sti.ufes.br/excad-extensao-de-cadastro-de-pessoas-sem-vinculo" target="_blank">STI - Serviços web - ExCAD</a>.
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-flex>
                </v-layout>

                <br>
                <br>

                <!-- O membro externo é estrangeiro? -->
                <v-layout row wrap justify-center>
                  <v-flex xs12>
                    <v-radio-group v-model="pessoa.estrangeiro" mandatory label="O membro externo é estrangeiro?"
                    >
                      <v-radio label="Sim" :value="true" ></v-radio>
                      <v-radio label="Não" :value="false" ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
                
                <!-- Nome -->
                <v-layout row wrap justify-center>
                  <v-flex xs12>
                    <v-text-field
                      label='Nome*'
                      counter='200'
                      v-model="pessoa.nome"
                      :rules="[...obrigatorio,...max200caracteres]"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <!-- Nome social -->
                <v-layout row wrap justify-center v-if="pessoa.estrangeiro === false">
                  <v-flex xs12>
                    <v-checkbox v-model="temNomeSocial" label="Possui nome social?"></v-checkbox>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-if="temNomeSocial"
                      label='Nome Social*'
                      counter='200'
                      v-model="pessoa.nomeSocial"
                      :rules="[...obrigatorio,...max200caracteres]"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <!-- CPF -->
                <v-layout row wrap justify-center v-if="pessoa.estrangeiro === false">
                  <v-flex xs12>
                    <v-text-field-cpf
                      label='CPF*'
                      v-model="pessoa.cpf"
                      v-bind:options="{
                        outputMask: '###.###.###-##',
                      }"
                      v-bind:properties="{
                        rules: obrigatorio
                    }"
                    />
                  </v-flex>
                </v-layout>

                <!-- Passaporte -->
                <v-layout row wrap justify-center v-if="pessoa.estrangeiro === true">
                  <v-flex xs12>
                    <v-text-field
                      label='Passaporte*'
                      counter='40'
                      v-model="pessoa.passaporte"
                      :rules="[...obrigatorio,...max40caracteres]">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <p class="mt-3"></p>

              </v-container>
            </v-form>

            <v-divider></v-divider>

            <!-- Botões "Cancelar" e "Cadastrar" -->
            <v-card-actions>

              <!-- Cancelar -->
              <v-btn color="primary" @click="cancelar">Cancelar</v-btn>
              
              <v-spacer></v-spacer>
              
              <!-- Cadastrar -->
              <v-btn color="primary" :disabled="!formularioValido" @click="cadastraMembroExterno()">Cadastrar</v-btn>

            </v-card-actions>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      formularioValido: false,
      temNomeSocial: false,
      pessoa: {
        nome: '',
        nomeSocial: '',
        cpf: '',
        passaporte: '',
        estrangeiro: false
      },
      obrigatorio: [v => !!v || 'Este campo é obrigatório'],
      max40caracteres: [v => v.length <= 40 || 'Este campo pode ter no máximo 40 caracteres'],
      max200caracteres: [v => v.length <= 200 || 'Este campo pode ter no máximo 200 caracteres'],
      excadServer: {}
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      // Cancelar.
      cancelar: function () {
        this.$router.go(-1)
      },
      // Cadastra membro externo.
      cadastraMembroExterno: function (avancar) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Cadastrando novo membro externo...' })
        if (!this.temNomeSocial) {
          this.pessoa.nomeSocial = this.pessoa.nome
        }
        projetos.postPessoa(this.pessoa)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.go(-1)
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Cadastrando novo membro externo...' })
        })
      }
    },
    mounted () {
      // Carrega endereço do ExCAD.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando endereço do servidor do ExCAD...' })
      projetos.getExcadServer()
      .then(response => {
        this.excadServer = response.data
        // Preenche o link com a URL do ExCAD.
        var excadServerUrl = this.excadServer.url
        document.getElementById('excadLink').setAttribute('href', excadServerUrl)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando endereço do servidor do ExCAD...' })
      })
    },

    components: {
      'basic-toolbar': BasicToolbar
    }
  }
</script>

<style lang="css">

  .center {
    text-align: center;
  }

  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }

  .input-group__icon-cb {
    cursor: pointer !important;
  }
  
</style>


// WEBPACK FOOTER //
// cadastrar-membro-externo.vue?d499d558